import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      oldPwd: null,
      newPwd: null,
      confirmPwd: null,
      error: null,
      index: 1
    };
  },
  methods: {
    back: function back() {
      this.$emit('back');
    },
    modify: function modify() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, res, _this, timer;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this2.valid()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              url = '/pjyy-deepexi-user-center/api/v1/common/updatePassword';
              _context.next = 5;
              return _this2.$getHttpClient().post(url, {
                id: accountStorage.getCacheUserInfo().userId,
                comfirmPwd: _this2.confirmPwd,
                oldPassword: _this2.oldPwd,
                newPassword: _this2.newPwd
              });
            case 5:
              res = _context.sent;
              if (res.data.code == '200') {
                _this2.$messageTip('修改成功,请重新登录', 'success');
                _this = _this2;
                timer = setTimeout(function () {
                  _this.$router.push({
                    name: 'v2-login'
                  });
                  clearTimeout(timer);
                }, 1000);
              } else {
                _this2.$messageTip(res.data.msg, 'error');
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    valid: function valid() {
      if (!this.oldPwd) {
        this.error = "请输入原密码";
        this.index = 1;
        this.$refs.oldPwd.focus();
        return false;
      }
      if (!this.newPwd) {
        this.error = "请输入新密码";
        this.index = 2;
        this.$refs.newPwd.focus();
        return false;
      }
      if (this.newPwd.length < 6) {
        this.error = "新密码至少6位";
        this.index = 2;
        this.$refs.newPwd.focus();
        return false;
      }
      if (!this.confirmPwd) {
        this.error = "请再次输入新密码";
        this.index = 3;
        this.$refs.confirmPwd.focus();
        return false;
      }
      if (this.newPwd != this.confirmPwd) {
        this.error = "确认密码和新密码不一致";
        this.index = 3;
        this.$refs.confirmPwd.focus();
        return false;
      }
      return true;
    }
  }
};